/**
 * @module mapbs.components.citymodel3d.citymodel3dservice.citymodel3dservice
 */
import angular from 'angular';
import ngeoLocation from 'ngeo/statemanager/Location.js';

const moduleCitymodelservice = angular.module('mapbsCitymodel3dService', []);

class Citymodel3dService {
    /**
   * @param {angular.$http} $http
   * @param {import("ngeo/statemanager/Location.js").StatemanagerLocation} ngeoLocation
   * @param {angular.$injector} $injector
   * @ngInject
   */
    constructor($http, ngeoLocation, $injector) {
        this.http = $http;
        this.location = ngeoLocation;
        this.injector = $injector;

        /** @type {string} */
        this.wmsUrl = this.injector.get('mapserverUrl');

        /** @type {string} */
        this.params =
      '&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureinfo&SRS=EPSG:4326&LAYERS=HM_DTM_Punktgitter_2012_2m&STYLES=&INFO_FORMAT=application/vnd.ogc.gml&WIDTH=10&HEIGHT=10&QUERY_LAYERS=HM_DTM_Punktgitter_2012_2m&X=5&Y=5&BBOX=';
    }

    /**
   * @export
   * @param {number} easting Easting (EPSG:4326).
   * @param {number} northing Northing (EPSG:4326).
   */
    getUrl(easting, northing, scaleValues, startingMap) {
        const boundingBox = this.createBoundingBox(easting, northing);
        const distance = this.getDistance(scaleValues) * 80 / 100;

        if (startingMap === null || startingMap === undefined) {
            startingMap = '';
        }
        return this.getElevation(boundingBox).then((height) => {
            const url = `https://3d.geo.bs.ch/?lat=${northing}&lon=${easting}&height=${height}&elevation=${distance}${startingMap}&pitch=-60`;
            return url;
        });
    }

    /**
   * @private
   * @param {number} easting
   * @param {number} northing
   * @return {string} boundingBox
   */
    createBoundingBox(easting, northing) {
        return `${easting - 0.001},${northing - 0.001},${easting + 0.001},${
            northing + 0.001
        }`;
    }

    /**
   * @return {number} distance
   */
    getDistance(scaleValues) {
        const mapZoom = this.location.getParam('map_zoom');
        let scale;
        const maxScale = 5000;
        const minScale = 500;
        const maxDistance = 2000;
        const minDistance = 250;

        if (typeof mapZoom === 'undefined' || mapZoom === '' || !scaleValues || !scaleValues.values) {
            scale = maxScale;
        } else {
            scale = scaleValues['values'][Number(mapZoom)];
            if (scale > maxScale) {
                scale = maxScale;
            } else if (scale < minScale) {
                scale = minScale;
            }
        }

        const distance =
      ((maxDistance - minDistance) * (scale - minScale)) /
        (maxScale - minScale) +
      minDistance;
        return distance.toFixed(2);
    }

    /**
   * @private
   * @param {string} boundingBox
   */
    getElevation(boundingBox) {
        if (boundingBox) {
            return this.http
        .get(`${this.wmsUrl}?${this.params}${boundingBox}`)
        .then((response) => {
            return response.data.match(/<value_0>(\d+(\.\d+)?)<\/value_0>/i)[1];
        });
        }
    }
}

moduleCitymodelservice.service('mapbsCitymodel3dService', Citymodel3dService);

export default moduleCitymodelservice;
